import { createFileRoute } from "@tanstack/react-router";
import { ARIZONA_PAGES } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/arizona-home-services-ppc-agency")({
  head: () => localPageHead(ARIZONA_PAGES.arizona!),
  component: ArizonaPage,
});

function ArizonaPage() {
  return <LocalPageView page={ARIZONA_PAGES.arizona!} />;
}
